import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";
import InlineTextDisplay from '../Controls/InlineTextDisplay';
import * as CreDtos from "../../CRE.dtos";
import { AustraliaMap } from '../../shared';
import { PublishedItem } from '../../components/Publications/PublishedItem';

class ResourceItem extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevprops) {
        if (this.props.id != prevprops.id) {
            window.scrollTo(0, 0);
        }
    }

    render() {
        if (!this.props.resourceItem || this.props.isLoading) {
            return (<div></div>);
        }

        let item: CreDtos.Publication = { ...this.props.resourceItem };

        let mapActiveCss = "map-active-yellow";
        let recruitingCss = "base1-bg";
        let focusBadgeCss = "focus-badge focus-badge-yellow";

        let titleHtml = item.title;
        if (item.titleExt && item.titleExt.length > 0) {
            titleHtml = titleHtml + '<br />' + item.titleExt;
        }

        let authorsRender = item.authors.map((content, index) => {
            return <span key={"authors" + index}>{content}{item.authors.length == index + 1 ? "" : ","} </span>
        });

        let focusRender = item.focus.map((content, index) => {
            return <div key={"focus" + index}>
                <div className=""><span>{content}</span></div>
            </div>
        });

        let australiaMap;
        if (item) {
            australiaMap = (
                <div className="text-center">
                    {item.isInternational ? <img width="100%" src={require("../../assets/img/world-map.png")} /> : <AustraliaMap states={item.states} activeCss={mapActiveCss} disabledCss="map-disabled-light" />}
                </div>
            );
        }

        
        let details = <div className="row mt-5">
            <div className="research-content col-12 col-md-9">
                <p> {item.publishedby}</p>
                <strong>SUMMARY</strong>
                <p>{item.summary}</p>
                <div><a className="emphasis-link" target="_blank" href={item.link}><u>view resource</u></a></div>
             </div>
            <div className="research-sidebar col-12 col-md-3">
                {australiaMap}
                <h6>YEAR</h6>
                {item.year}
                <h6 className="mt-4">FOCUS</h6>
                {focusRender}
                <h6 className="mt-4">AUTHORS</h6>p
                {authorsRender}
            </div>

        </div>

        return (<div  id="SectionContainer" ref="research-detail" >
            <section  className="content page-content" >
                <div>
                    <div className="container">
                        <div className="mb-2" >
                            <h1 className="my-5" dangerouslySetInnerHTML={{ __html: titleHtml }}></h1>
                        </div>
                        {details}
                    </div>
                </div>
            </section>
        </div>
        );
    }
}

const getResourceItem = (resources: CreDtos.Publication[], id) => {
    if (resources && resources.length > 0) {
        let resourceItem = resources.filter(r => r.anchor && r.anchor.toLowerCase() == id.toLowerCase());
        if (resourceItem.length > 0) {
            return resourceItem[0];
        }
        resourceItem = resources.filter(r => r.id.toString() == id);
        if (resourceItem.length > 0) {
            return resourceItem[0];
        }
    }
    return {};
}

const mapStateToProps = (state, ownProps) => {
    return {
        resourceItem: getResourceItem(state.siteData.siteData.resources, ownProps.match.params.id),
        id: ownProps.match.params.id,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const ResourceItemContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(
    ResourceItem
));

export default ResourceItemContainer;


// WEBPACK FOOTER //
// ./src/components/Resources/ResourceItem.tsx